import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, InputDate, Checkbox } from 'components/fields'
import { Button } from 'components/misc'
import { validateAddPreparationTraining } from 'models/awards'
import { form } from 'helpers/decorators'

@form({
  form: 'add-preparation-training',
  validate: validateAddPreparationTraining
})
class AddUserPreparationTraining extends Component {
  static propTypes = {
    addPreparationTraining: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    awardId: PropTypes.number,
    collection: PropTypes.array.isRequired
  }

  render() {
    const { handleSubmit, awardId, collection } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.addPreparationTraining(awardId, collection, fields)
        )}
      >
        <div className="row">
          <div className="col-xs-6">
            <Input label="Activity" intlKey="label.activity" name="name" />
          </div>
          <div className="col-xs-3">
            <InputDate label="Activity" intlKey="label.activity" name="date" />
          </div>
          <div className="col-xs-3">
            <Checkbox
              label="Is completed"
              intlKey="label.is_completed"
              name="isCompleted"
              justify
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              intlKey="button.close"
              type="button"
              onClick={() => this.props.modal(null)}
              secondary
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button intlKey="button.add">Add</Button>
          </div>
        </div>
      </form>
    )
  }
}

export default AddUserPreparationTraining
